/**
 * Section: Newsletter Modal
 * ------------------------------------------------------------------------------
 * Newsletter modal configuration for complete theme support
 * - https://github.com/Shopify/theme-scripts/tree/master/packages/theme-sections
 *
 * @namespace newsletterModal
 */

import log from 'salvo-lite/log'

import debounce from 'lodash-es/debounce'
import {register} from '@shopify/theme-sections'

import breakpoints from '../helpers/breakpoints'
import {on} from '../helpers/utils'

class SiteFooter {
    constructor () {
        this._selectors = {
            container: '.container',
            legalAccordion: '[data-component-id="footer-legal-accordion"]',
            footerAccordion: '[data-component-id="footer-masonry-accordion"]'
        }

        /**
         * Instance globals.
         */
        this._legalAccordion = {}
        this._footerMasonry = {}
        this._footerAccordion = {}

        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit (theme, section) {
        register('site-footer', {

            /**
             * Custom public section method.
             */
            init () {
                this.section = theme.getSectionsByType('site-footer')
                this._footerMasonryComponent = theme._components.find(item => item.constructor.name === 'Masonry' && item._elem.getAttribute('data-component-id') === 'footer-masonry-accordion')
                this._footerAccordionComponent = theme._components.find(item => item.constructor.name === 'Accordion' && item._elem.getAttribute('data-component-id') === 'footer-masonry-accordion')
                this._footerLegalAccordionComponent = theme.getComponentsById('footer-legal-accordion')

                if (this._footerAccordionComponent) {
                    this.setResizeEvent()
                    this.setDefaultStates()
                }
            },

            setDefaultStates () {
                if (window.matchMedia(`(max-width: ${breakpoints.medium})`).matches) {
                    return
                }
                this.openAccordion()
            },

            /**
             * Callback function when section is loaded via 'sections.load()' or by the Theme Editor 'shopify:section:load' event.
             */
            onLoad () {
                this.init()
            },

            hideAccordion () {
                this._footerAccordionComponent._hideAllItems()
            },

            /**
             * Open all accordion items.
             */
            openAccordion () {
                this._footerAccordionComponent._showAllItems()
            },

            /**
             * Handle resize events.
             */
            handleResizeEvents () {
                if (window.matchMedia(`(max-width: ${breakpoints.medium})`).matches) {
                    this._footerMasonryComponent.destroy()
                    this._footerAccordionComponent._hideAllItems()
                    return
                }

                this._footerMasonryComponent.reload()
            },

            /**
             * Set accordion toggle event after document has loaded styling.
             */
            setResizeEvent () {
                on('resize', debounce(() => this.handleResizeEvents(), 250))
            }
        })
    }
}

export default SiteFooter



// WEBPACK FOOTER //
// ./src/resources/scripts/sections/SiteFooter.js